var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "button button-primary filters__apply-button",
      class: { "is-tab2": _vm.isTab2 },
      attrs: { tabindex: "0" },
      on: {
        click: _vm.applyFiltersToSearch,
        keypress: _vm.applyFiltersToSearch,
      },
    },
    [_vm._v("\n  " + _vm._s(_vm.applyFiltersText) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }